import { render } from "./PairScan.vue?vue&type=template&id=d1c27232&scoped=true"
import script from "./PairScan.vue?vue&type=script&lang=ts"
export * from "./PairScan.vue?vue&type=script&lang=ts"

import "./PairScan.vue?vue&type=style&index=0&id=d1c27232&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d1c27232"

export default script